import React from "react";
var __jsx = React.createElement;
import stl from "./MobileOffers.module.css";
import { useTranslation } from "@i18n";
import BreadCrumb from "@componentsShared/BreadCrumb";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import Layout from "@/_LayoutsRelated/layout/Layout";
import useHelpers from "@hooks/useHelpers";
import { PageNamesEnum } from "@/routes/routes";
function MobileOffers() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var offers = useFullPageData(PageNamesEnum.PAGE_NAME__MobileOffers);
  if (!offers) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    pageName: "offers",
    headHideLinks: true,
    disableLoader: true,
    hideOrangeHeadBtn: true,
    revampedHEading: false,
    revampedSearch: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "container ".concat(stl.mobileOfferContainer)
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.offersBrdCrmb,
    links: [{
      title: t("عروض السيارات", {
        ns: "web_common"
      })
    }]
  }), /*#__PURE__*/React.createElement("h1", {
    className: stl.offersTitle
  }, t("عروض السيارات", {
    ns: "web_offers"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.offersCintainer
  }, (offers === null || offers === void 0 ? void 0 : offers.length) > 0 && offers.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: createUrl("/deal/".concat(item.id, "#referral_location=offerspage&browse_variant=deals&variant_value=").concat(item === null || item === void 0 ? void 0 : item.id))
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.imgContainer
    }, /*#__PURE__*/React.createElement("img", {
      src: item.box_img_mobile,
      alt: item.deal_box_img_title,
      width: 274,
      height: 230
    })), /*#__PURE__*/React.createElement("h2", null, item.deal_box_img_title));
  }))));
}
export default MobileOffers;